import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { LanguageService } from 'src/app/services/language.service';
import { TabId } from 'src/app/enums/tab-id.enum';
import { finalize, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ai-search',
  templateUrl: './ai-search.component.html',
  styleUrls: ['./ai-search.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class AiSearchComponent implements OnInit {
  query: string = '';
  isLoading: boolean = false;
  errorMessage: string = '';
  currentLanguage: string = 'he';

  constructor(
    private apiService: ApiService,
    private languageService: LanguageService,
    private router: Router
  ) {
    // Initialize immediately in constructor
    const currentLang = this.languageService.currentLanguage.value;
    this.currentLanguage = currentLang;
  }

  ngOnInit(): void {
    // Subscribe to language changes
    this.languageService.currentLanguage$.subscribe(lang => {
      this.currentLanguage = lang;
    });
  }

  onSearch(): void {
    if (!this.query.trim()) {
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    // Open tab immediately
    const newTab = window.open('', '_blank');
    
    if (!newTab) {
      this.errorMessage = 'Please allow popups for this site';
      this.isLoading = false;
      return;
    }

    // Show loading message
    newTab.document.write(`
      <html>
        <head>
          <title>...מעבד שאילתה</title>
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
        </head>
        <body style="display:flex;align-items:center;justify-content:center;height:100vh;margin:0;font-family:Assistant,Arial,sans-serif;background:linear-gradient(135deg, #002649 0%, #004080 100%)">
          <div style="text-align:center;background:white;padding:5rem 10rem;border-radius:16px;box-shadow:0 10px 40px rgba(0,0,0,0.2)">
            <i class="fas fa-spinner fa-spin" style="font-size:3rem;color:#002649;margin-bottom:1.5rem"></i>
            <h2 style="color:#002649;margin:0 0 0.5rem 0;font-weight:600">...מעבד שאילתה</h2>
          </div>
        </body>
      </html>
    `);

    this.apiService['request']<any>('POST', `${environment.backendUrl}/natural-language-query/parse`, { query: this.query })
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (parsedQuery) => {
          const queryParams: any = { entity_index: 0, tabId: TabId.LIST };
          
          // Add all array fields from parsedQuery
          Object.keys(parsedQuery).forEach(key => {
            if (parsedQuery[key]?.length) {
              queryParams[key] = parsedQuery[key].join(',');
            }
          });

          const url = `${window.location.origin}/?${new URLSearchParams(queryParams).toString()}`;
          newTab.location.href = url;
        },
        error: (error) => {
          console.error('Error parsing query:', error);
          this.errorMessage = this.currentLanguage === 'he' ? 'אירעה שגיאה בפענוח השאילתה' : 'An error occurred while parsing the query';
          newTab.close();
        }
      });
  }

  onCancel(): void {
    this.isLoading = false;
    this.errorMessage = '';
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.onSearch();
    }
  }
}
